import styled from 'styled-components';

interface PersonalDataContainerProps {
  suOptinForm?: boolean;
  isEdition?: boolean;
}

export const PersonalDataContainer = styled.div<PersonalDataContainerProps>`
  position: absolute;
  top: 34vh;
  right: 5vw;
  left: 5vw;
  z-index: 5;
  ${(props): string => (props.suOptinForm === true ? 'top: 31vh;' : '')}
  ${(props): string => {
    if (props.isEdition === true) {
      return `
        &:hover {
            -webkit-box-shadow: inset 0 0 2px 0 black;
            box-shadow: inset 0 0 2px 0 black;
        }
      `;
    }
    return '';
  }}
`;
PersonalDataContainer.displayName = 'PersonalDataContainer';
